import { FormControl, FormLabel, Typography } from '@mui/material';
import { InputDatePicker } from '@retail/components';

interface Props {
  value?: Date;
  minDate?: Date;
  maxDate?: Date;
  clearable?: boolean;
  includeUnderline?: boolean;
  disabled?: boolean;
  label?: string;
  setNewDate: (newDate: Date | null) => void;
}

export function DateSelectField({
  value,
  minDate,
  maxDate,
  clearable = false,
  includeUnderline = false,
  disabled,
  label,
  setNewDate,
}: Props) {
  return (
    <FormControl sx={{ display: 'flex', flexDirection: 'column', minWidth: 180, width: 180 }}>
      {label && (
        <FormLabel id={'datePickerLabel'}>
          <Typography variant="subtitle1">{label}</Typography>
        </FormLabel>
      )}
      <InputDatePicker
        value={value ?? null}
        onChange={(e) => setNewDate(e)}
        disabled={disabled}
        minDate={minDate ?? new Date()}
        maxDate={maxDate}
        slotProps={{
          field: { clearable },
          textField: {
            variant: 'standard',
            placeholder: '-',
            sx: { minWidth: clearable ? 176 : 140, width: clearable ? 176 : 140 },
            InputProps: { disableUnderline: !includeUnderline },
            inputProps: { readOnly: true },
          },
        }}
      />
    </FormControl>
  );
}
